import React, { useState } from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import { WContainer, Breadcrumbs, MainTitle, MainDescription } from '@next-nx/shared-ui/atoms'
import { ContattaciBox } from '@next-nx/shared-ui/molecules'
import {
  FaqHome,
  FormRichiestaPreventivoModal,
  Page,
  RichiestaPreventivoThankYouModal,
  StoreLocatorHelpBanner,
} from '@next-nx/shared-ui/organisms'
import { useCreateRichiestaContattoMutation } from '@next-nx/shared-graphql/unipolrental'
import styles from './ContattaciTemplate.module.sass'

interface Props {
  pagina?: any
}

const ContattaciTemplate = (props: Props) => {
  const { pagina = {} } = props

  const t = useTrans()

  const [openFormRichiestaPreventivoModal, setOpenFormRichiestaPreventivoModal] = useState(false)
  const [openRichiestaPreventivoThankYouModal, setOpenRichiestaPreventivoThankYouModal] =
    useState(false)
  const [statusRichiestaPreventivoThankYouModal, setStatusRichiestaPreventivoThankYouModal] =
    useState<string | undefined>()

  const [createRichiestaContattoMutation] = useCreateRichiestaContattoMutation()

  const contattaciMenu = useFindMenu('pagina-contattaci')

  const soccorsoStradale = {
    name: 'Hai bisogno del soccorso stradale?',
    description: '<p>Contatta il nostro numero verde gratuito per ricevere soccorso stradale.</p>',
    style: 'assistenza_illustration',
  }
  const preventivo = {
    style: 'preventivo_light_illustration',
    name: 'Hai bisogno di un preventivo su un veicolo?',
    description:
      '<p>Compila il form di richiesta preventivo per essere ricontattato da un nostro consulente.</p>',
    children: {
      edges: [
        { node: { pk: 1, name: 'Richiedi un preventivo', url: '/', key: 'richiesta_preventivo' } },
        { node: { pk: 2, name: 'Oppure vai in Agenzia', url: '/agenzie' } },
      ],
    },
  }
  const target = {
    style: 'area_riservata_illustration',
    name: 'Sei un cliente, un fleet manager o un utilizzatore?',
    description:
      '<p>Accedi all’area riservata per visualizzare la documentazione contrattuale, i dati relativi al veicolo/i, la reportistica e gestire i driver.</p>',
    children: {
      edges: [
        {
          node: {
            pk: 1,
            name: 'Accedi all’area riservata',
            key: 'area_riservata_contattaci',
            url: 'https://unipolrental.link/areaclienti',
            blank: true,
          },
        },
      ],
    },
  }

  const faqsMenu = useFindMenu('faq', contattaciMenu)
  const faqBoxMenu = useFindMenu('faq-box', contattaciMenu)

  const storeLocator = {
    name: 'Sempre al tuo fianco con le nostre filiali e strutture convenzionate',
    ctaLabel: 'Vai allo store locator',
    url: '/store-locator',
  }
  const storeLocatorBoxLink = {
    name: 'Scopri le nostre Agenzie',
    ctaLabel: 'Vai alle Agenzie UnipolSai',
    url: '/agenzie',
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina.titolo} className={styles.title} />
        <MainDescription html={pagina.descrizione} className={styles.descrizione} />
        <div className={styles.list}>
          <div className={`${styles.item} ${styles['item--blue']}`}>
            <ContattaciBox
              item={preventivo}
              colorVariant="white"
              onClick={() => setOpenFormRichiestaPreventivoModal(true)}
            />
          </div>
          <div className={styles.item}>
            <ContattaciBox item={target} />
          </div>
          <div className={styles.item}>
            <ContattaciBox
              item={soccorsoStradale}
              numeroVerde
              numeroVerdeDescription={t('Chiama il numero verde gratuito')}
            />
          </div>
        </div>
      </WContainer>
      <FaqHome
        item={faqsMenu}
        boxItem={faqBoxMenu}
        bgVariant="lightblue"
        className={styles.faq}
        hideBoxOnMobile
      />
      <StoreLocatorHelpBanner
        item={storeLocator}
        boxLinkItem={storeLocatorBoxLink}
        className={styles.storeLocator}
      />
      <FormRichiestaPreventivoModal
        open={openFormRichiestaPreventivoModal}
        setOpen={setOpenFormRichiestaPreventivoModal}
        mutation={createRichiestaContattoMutation}
        onSubmit={(status) => {
          setOpenFormRichiestaPreventivoModal(false)
          setOpenRichiestaPreventivoThankYouModal(true)
          setStatusRichiestaPreventivoThankYouModal(status)
        }}
      />
      <RichiestaPreventivoThankYouModal
        open={openRichiestaPreventivoThankYouModal}
        setOpen={setOpenRichiestaPreventivoThankYouModal}
        status={statusRichiestaPreventivoThankYouModal}
      />
    </Page>
  )
}

export default ContattaciTemplate
